import { render, staticRenderFns } from "./DiyStatistic.vue?vue&type=template&id=0f053621&scoped=true"
import script from "./DiyStatistic.vue?vue&type=script&lang=js"
export * from "./DiyStatistic.vue?vue&type=script&lang=js"
import style0 from "./DiyStatistic.vue?vue&type=style&index=0&id=0f053621&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f053621",
  null
  
)

export default component.exports